import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { appRoutes } from './routes';



@NgModule({
  imports: [RouterModule.forRoot(appRoutes,{ enableTracing: false } )],
  exports: [RouterModule]
})
export class AppRoutingModule { }
